export default class ThreadManager {
    constructor() {

        this.threadPool = [];
        this.threadCounter = 0;
        this.threadCap = 5;

        this.handleMessageEvent = this.handleMessageEvent.bind(this);
        this.cleanThreads = this.cleanThreads.bind(this);
        this.createThread = this.createThread.bind(this);
        this.executeThread = this.executeThread.bind(this);
        this.createThreadAndExecute = this.createThreadAndExecute.bind(this);
        this.executeThreadList = this.executeThreadList.bind(this);
        this.createThreadListAndExecute = this.createThreadListAndExecute.bind(this);

        this.methodLibrary = {
            // General
            jsonParse: 'general',

            // Blast
            organizeBlastEmployee: 'blast',
            mapBlastData: 'blast',
        }

        this.threadCleanInterval = setInterval(() => {
            this.cleanThreads();
        }, 15000);
    }

    async handleMessageEvent(thread, msg) {

        thread.isWorking = false;
        thread.isStaged = false;
        if (thread.callback != undefined && thread.callback != null) {
            thread.callback(msg.data);
        }
    }

    cleanThreads() {

        for (var i = 0; i < this.threadPool.length; i++) {
            let tmpThread = this.threadPool[i];
            if (!tmpThread.isWorking && !tmpThread.isStaged && (new Date()).getTime() - tmpThread.lastUse >= 30000) {
                tmpThread.worker.terminate();
                this.threadPool.splice(i--, 1);
            }
        }
    }

    async createThread(methodName, data, callback) {
        let workerType = this.methodLibrary[methodName];
        let threadPath = '';
        switch (workerType) {
            case "blast":
                threadPath = 'BlastWorker.js';
                break;
            case "general":
                threadPath = 'GeneralWorker.js';
                break;
            default: return null;
        }

        threadPath = window.__globalConfig.webworkerPath + threadPath;

        let thread = null;
        for (var i = 0; i < this.threadPool.length; i++) {
            if (!this.threadPool[i].isWorking && !this.threadPool[i].isStaged && this.threadPool[i].threadPath === threadPath) {
                thread = this.threadPool[i];
            }
        }

        if (thread === null) {
            thread = {
                id: this.threadCounter++,
                worker: new Worker(threadPath),
                threadPath: threadPath,
                isWorking: false,
                isStaged: true,
                lastUse: (new Date()).getTime(),
                callback: callback,
                message: {
                    payload: data,
                    method: methodName
                }
            }

            thread.worker.addEventListener('message', this.handleMessageEvent.bind(null, thread))

            this.threadPool.push(thread);
        } else {
            thread.isStaged = true;
            thread.lastUse = (new Date()).getTime();
            thread.callback = callback;
            thread.message = {
                payload: data,
                method: methodName
            }
            //thread.worker.removeEventListener('message', thread.eventListenerFunction);
        }

        return thread;
    }

    async executeThread(thread) {
        if (thread != undefined && thread != null && !thread.isWorking) {
            thread.isWorking = true;
            // thread.eventListenerFunction = (msg) => {
            //     thread.isWorking = false;
            //     thread.isStaged = false;
            //     if (thread.callback != undefined && thread.callback != null) {
            //         thread.callback(msg.data);
            //     }
            // };
            // thread.worker.addEventListener('message', thread.eventListenerFunction);
            thread.worker.postMessage(thread.message);
        }
    }

    async createThreadAndExecute(methodName, data, callback) {
        let thread = await this.createThread(methodName, data, callback);
        this.executeThread(thread);
        return thread;
    }

    async executeThreadList(threadList, callback) {
        if (threadList.length != undefined) {
            for (var i = 0; i < threadList.length; i++) {
                this.executeThread(threadList[i]);
            }

            let threadCheckInterval = setInterval(() => {
                let finished = true;
                for (var i = 0; i < threadList.length; i++) {
                    if (threadList[i].isWorking) {
                        finished = false;
                    }
                }
                if (finished) {
                    if (callback) {
                        callback();
                    }
                    clearInterval(threadCheckInterval);
                }
            }, 50);
        }
    }

    async createThreadListAndExecute(threadTemplates, callback) {
        if (threadTemplates.length != undefined) {
            let threadList = [];
            for (var i = 0; i < threadTemplates.length; i++) {
                threadList.push(await this.createThreadAndExecute(threadTemplates[i].method, threadTemplates[i].data, threadTemplates[i].callback));
            }

            let threadCheckInterval = setInterval(() => {
                let finished = true;
                for (var i = 0; i < threadList.length; i++) {
                    if (threadList[i].isWorking) {
                        finished = false;
                    }
                }
                if (finished) {
                    if (callback) {
                        callback();
                    }
                    clearInterval(threadCheckInterval);
                }
            }, 50);
        }
    }
}